// extracted by mini-css-extract-plugin
export default {"buttonTopMargin":"ChangePassword_buttonTopMargin__sSHfZ","passwordPage":"ChangePassword_passwordPage__mlPXG","userSpan":"ChangePassword_userSpan__io0tB"};